module.exports = __webpack_public_path__ + "img/icon_14.cb465398.png";